import { test, enforce, create } from 'vest'
import validators from '../../../utils/validators'

enforce.extend({
  isValidEmail: validators.validateEmail,
})

export const formValidation = create((data = {}) => {
  const { email } = data

  test('email', 'Email must be valid!', () => {
    enforce(email).isValidEmail()
  })
})
